import logo_pp_sm from '../../../assets/images/logo-portplay-stacked.svg';
import logo_pp_lg from '../../../assets/images/logo-portplay-horizontal.svg';
import icon_top from '../../../assets/images/icon-top.svg';
import icon_discord from '../../../assets/images/icon-discord.png';
import icon_mail from '../../../assets/images/icon-mail.png';
import bg_skyline from '../../../assets/images/background-skyline.png';
import tabletop_games from '../../../assets/images/tabletop-games.png';
import icon_tabletop from '../../../assets/images/icon-tabletop-01.svg';
import icon_epic from '../../../assets/images/icon-epic-01.svg';
import icon_group from '../../../assets/images/icon-group-01.svg';
import icon_talks from '../../../assets/images/icon-talks-01.svg';
import icon_makers_market from '../../../assets/images/icon-market-01.svg';
import kids from '../../../assets/images/kidsdnd.png';
import talks_presentations from '../../../assets/images/talks-presentations.png';
import epic from '../../../assets/images/dndatcon.png';
import makers_market from '../../../assets/images/makersmarket.png';
import soundgame_header from '../../../assets/images/soundgameheader.png';
import indiegames from '../../../assets/images/indiegames.jpg';
import group_games from '../../../assets/images/group-games.png';
import w_blood from '../../../assets/images/what-to-expect-blood-on-the-clocktower.jpg';
import w_dand from '../../../assets/images/what-to-expect-blasphemy.jpg';
import w_dark_vigil from '../../../assets/images/what-to-expect-dark-vigil.jpg';
import w_hobbits from '../../../assets/images/what-to-expect-hobbit-hoedown.jpg';
import w_kings_poisoner from '../../../assets/images/what-to-expect-the-kings-poisoner.jpg';
import w_virtuosa from '../../../assets/images/what-to-expect-virtuosa.jpg';


import styled from 'styled-components'

const Wrapper = styled.div<{$img: string}>`
padding-top: 3rem;
width: 100%;
max-width: 1640px;

  .pp-logo-sm {
    display: block;
  }
  .pp-logo-lg {
    display: none;
  }

  @media (min-width: 992px) {
    .pp-logo-sm {
      display: none;
    }
    .pp-logo-lg {
      display: block;
    }
  }

  .back-to-top {
    position: fixed;
    top: 600px;
    right: 30px;
    min-width: 80px;
    min-height: 80px;
    z-index: 300;
  }

  .pillar-one-layout, .pillar-two-layout {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr 1fr 1fr 1fr 1fr;
    column-gap: 0.5rem;
    row-gap: 0.5rem;
  }

  @media (min-width: 992px) {
    .pillar-one-layout {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr;
      grid-template-rows: 1fr 1fr;
      column-gap: 0.5rem;
      row-gap: 0.5rem;
    }

    .pillar-two-layout {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr;
      grid-template-rows: 1fr 1fr;
      column-gap: 0.5rem;
      row-gap: 0.5rem;
    }
  }

  .item-1 {grid-column: 1 / 2; grid-row: 1 / 2;}
  .item-2 {grid-column: 1 / 2; grid-row: 2 / 3;}
  .item-3 {grid-column: 1 / 2; grid-row: 3 / 4;}
  .item-4 {grid-column: 1 / 2; grid-row: 4 / 5;}
  .item-5 {grid-column: 1 / 2; grid-row: 5 / 6;}
  .item-6 {grid-column: 1 / 2; grid-row: 6 / 7;}

  .item-7 {grid-column: 1 / 2; grid-row: 1 / 2;}
  .item-8 {grid-column: 1 / 2; grid-row: 2 / 3;}
  .item-9 {grid-column: 1 / 2; grid-row: 3 / 4;}
  .item-10 {grid-column: 1 / 2; grid-row: 4 / 5;}
  .item-11 {grid-column: 1 / 2; grid-row: 5 / 6;}
  .item-12 {grid-column: 1 / 2; grid-row: 6 / 7;}

  @media (min-width: 992px) {
    .item-1 {grid-column: 1 / 2; grid-row: 1 / 2;}
    .item-2 {grid-column: 2 / 3; grid-row: 1 / 2;}
    .item-3 {grid-column: 3 / 4; grid-row: 1 / 2;}
    .item-4 {grid-column: 4 / 5; grid-row: 1 / 2;}
    .item-5 {grid-column: 1 / 3; grid-row: 2 / 3;}
    .item-6 {grid-column: 3 / 5; grid-row: 2 / 3;}

    .item-7 {grid-column: 1 / 3; grid-row: 1 / 2;}
    .item-8 {grid-column: 3 / 5; grid-row: 1 / 2;}
    .item-9 {grid-column: 2 / 4; grid-row: 2 / 3;}
    .item-10 {grid-column: 1 / 2; grid-row: 2 / 3;}
    .item-11 {grid-column: 2 / 3; grid-row: 2 / 3;}
    .item-12 {grid-column: 3 / 4; grid-row: 2 / 3;}
  }


  .contact-us {
    background-image: url('${props => props.$img}');
    background-position: center bottom;
    background-repeat: no-repeat;
    background-position: center; background-size: cover;
    max-height: 1000px;

    padding-top: 3rem;
    padding-bottom: 2rem;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr;
  }

  .contact-us-item-1 {
    margin-right: 2rem;
    max-height: 200px;
  }

  @media (min-width: 992px) {
    .contact-us {      
      max-height: 100%;

      display: grid;
      grid-template-columns: 1fr 2fr;
      grid-template-rows: 1fr;
      column-gap: 0.5rem;
    }
    .contact-us-item-1 {
      max-height: 100%;
    }
  }

  .icon-item-tabletop-games, .icon-item-group-games, .icon-item-talks, .icon-item-makers, .icon-item-kids, .icon-item-epic {
    position: absolute;
    width: 100px;
    height: 100px;
    top: 130px;
    left: 0;
    right: 0;
    margin: 0 auto;
    z-index: 12;
  }

  .pilars-item-tabletop-games {
    position: relative;
    background-image: url('${tabletop_games}');
    background-position: center; background-size: cover;
  }
  .icon-item-tabletop-games {
    background-image: url('${icon_tabletop}');
  }
  .pilars-item-group-games {
    position: relative;
    background-image: url('${group_games}');
    background-position: center; background-size: cover;
  }
  .icon-item-group-games {
    background-image: url('${icon_group}');
  }
  .pilars-item-talks {
    position: relative;
    background-image: url('${talks_presentations}');
    background-position: center; background-size: cover;
  }
  .icon-item-talks {
    background-image: url('${icon_talks}');
  }
  .pilars-item-makers {
    position: relative;
    background-image: url('${makers_market}');
    background-position: center; background-size: cover;
  }
  .icon-item-makers {
    background-image: url('${icon_makers_market}');
  }
  .pilars-item-kids {
    position: relative;
    background-image: url('${kids}');
    background-position: center; background-size: cover;
  }
  .icon-item-kids {
    background-image: url('${icon_epic}');
  }
  .pilars-item-epic {
    position: relative;
    background-image: url('${epic}');
    background-position: center; background-size: cover;
  }
  .icon-item-epic {
    background-image: url('${icon_epic}');
  }

  .pilars-item-blood {
    position: relative;
    background-image: url('${w_blood}');
    background-position: center; background-size: cover;
  }
  .pilars-item-dand {
    position: relative;
    background-image: url('${w_dand}');
    background-position: center; background-size: cover;
  }
  .pilars-item-dark-vigil {
    position: relative;
    background-image: url('${w_dark_vigil}');
    background-position: center; background-size: cover;
  }
  .pilars-item-hobbits {
    position: relative;
    background-image: url('${w_hobbits}');
    background-position: center; background-size: cover;
  }
  .pilars-item-kings-poisoner {
    position: relative;
    background-image: url('${w_kings_poisoner}');
    background-position: center; background-size: cover;
  }
  .pilars-item-virtuosa {
    position: relative;
    background-image: url('${w_virtuosa}');
    background-position: center; background-size: cover;
  }

  .pilars-item-dnd-epic {
    position: relative;
    background-image: url('${indiegames}');
    background-position: center; background-size: cover;
  }
  .pilars-item-kids-games {
    position: relative;
    background-image: url('${kids}');
    background-position: center; background-size: cover;
  }
  .pilars-item-sound-game {
    position: relative;
    background-image: url('${soundgame_header}');
    background-position: center; background-size: cover;
  }


`
export const Home = () => {

  return (
    <Wrapper $img={bg_skyline}>
      
      <div className='back-to-top'>
        <a href='#top'><img src={icon_top} alt='back to top' /></a>
      </div>

      <div className='lr-padded-container'>
        <img src={logo_pp_sm} alt='port play' className='pp-logo-sm' />
        <img src={logo_pp_lg} alt='port play' className='pp-logo-lg' />
      </div>
      <div>&nbsp;</div>
      <div className='lr-padded-container center-text'>
        <h1 style={{marginBottom: '25px'}}>tabletop gaming & art festival</h1>
        <hr style={{maxWidth: '200px', marginInline: 'auto'}}/>
        <h2>St Kilda Town Hall and St Kilda Library, Melbourne, VIC</h2>
        <h2>Sat & Sun 18th – 19th April 2026</h2>
        <a href="https://events.humanitix.com/https-portplay-org" className='btn-pink' style={{margin: '0 auto'}}>Get your tickets here</a>
        <p style={{marginTop: '0.5rem', fontSize: 'var(--smallText)'}}>Kids tickets are free</p>
        <p style={{fontSize: 'var(--smallText)', marginBottom: '2rem'}}>Doors open 10:30am both days</p>
        <a href="https://aftergame.app/events/74aa19fa-71b3-4b6c-a741-d4349f14a07f" className='btn-pink' style={{margin: '0 auto'}}>Reserve Your Seat</a>
        <p style={{marginTop: '0.5rem', fontSize: 'var(--smallText)'}}>Save your spot at a table and see more event info</p>
        <div style={{maxWidth: '50%', margin: '0 auto'}}>
          <p>Port Play is a two day tabletop game and art festival held across two St Kilda venues, featuring playable games, workshops, presentations, and a Makers Market.</p>
          <p>The festival celebrates local tabletop gaming, creativity, and community play, with activities designed for children, families, and adults.</p>
        </div>
      </div>

      <div className='lr-padded-container'>
        <div className='pillar-one-layout'>
          <div className='item-1 pilars-item pilars-item-tabletop-games'><span style={{paddingBottom: '20px'}}>tabletop games</span>
            <div className='icon-item-tabletop-games'></div>
          </div>
          <div className='item-2 pilars-item pilars-item-group-games'><span style={{paddingBottom: '20px', textAlign: 'center', display: 'block'}}>group and party games</span>
            <div className='icon-item-group-games'></div>
          </div>
          <div className='item-3 pilars-item pilars-item-talks'><span style={{paddingBottom: '20px', textAlign: 'center', display: 'block'}}>talks & presentations</span>
            <div className='icon-item-talks'></div>
          </div>
          <div className='item-4 pilars-item pilars-item-makers'><span style={{paddingBottom: '20px'}}>Makers Market</span>
            <div className='icon-item-makers'></div>
          </div>
          <div className='item-5 pilars-item pilars-item-kids'><span style={{paddingBottom: '20px'}}>kids activities</span>
            <div className='icon-item-kids'></div>
          </div>
          <div className='item-6 pilars-item pilars-item-epic'><span style={{paddingBottom: '20px'}}>Huge D&D Epic Style</span>
            <div className='icon-item-epic'></div>
          </div>
        </div>
      </div>

      <div className='lr-padded-container center-text'>
        <h1>what to expect</h1>
        <p>Meet and play locally developed tabletop games and talk directly with their creators. Explore the Makers Market showcasing independent artists and game designers. Take part in workshops, presentations, and hands-on creative activities, with dedicated games for children and family-friendly sessions throughout the weekend.</p>
      </div>

      <div className='lr-padded-container'>
        <div className='pillar-two-layout'>
          <div className='item-7 pilars-item pilars-item-dnd-epic'><span style={{paddingBottom: '20px', textAlign: 'center', display: 'block'}}>local indie<br />tabletop showcase</span></div>
          <div className='item-8 pilars-item pilars-item-kids-games'><span style={{paddingBottom: '20px', textAlign: 'center', display: 'block'}}>Kids Games 8yo - 15yo</span></div>
          <div className='item-9 pilars-item pilars-item-sound-game'><span style={{paddingBottom: '20px', textAlign: 'center', display: 'block'}}>Group and Party Games</span></div>
        </div>
      </div>

      <div className='lr-padded-container center-text' style={{paddingBottom: '5.1rem'}}>
        <ul style={{listStyle: 'none', padding: 0, margin: 0}}>
          <li>That Sound Game</li>
          <li>Blood on the Clocktower</li>
          <li>King's Poisoner</li>
          <li>Blasphemy</li>
        </ul>
      </div>

      <div className='lr-padded-container center-text' style={{marginTop: '-2rem'}}>
        <p>This tabletop and art festival is presented by ARC in partnership with the City of Port Phillip. We are excited to showcase creative local talent and welcome players of all ages and experience levels.</p>
      </div>

      <div className='contact-us lr-padded-container'>
        <div className='contact-us-item-1'>
          <h2 style={{marginTop:'0px'}}>Contact us</h2>
          <p>If you'd like to learn more about ARC, join us on our Discord server or email us directly at <a href='mailto:arcanacon.orgs@gmail.com'>arcanacon.orgs@gmail.com</a>.</p>
          <div className='left-align-container'>
            <div style={{marginRight: '1.5rem'}}><a href="https://discord.gg/M9Wq7wzdC4"><img src={icon_discord} alt='discord' style={{width:'60px', height: '60px'}}/></a></div>
            <div><a href='mailto:arcanacon.orgs@gmail.com'><img src={icon_mail} alt='email arc' style={{width:'60px', height: '60px'}}/></a></div>
          </div>
        </div>
        {/* <EmailUsForm/> */}
      </div>
      


     
    </Wrapper>
  )
}